import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment';
import DatePicker from 'components/DatePicker';
import StyledSelect from 'components/StyledSelect';
import { EditableTableRow, EditableTableCell } from 'components/EditableTable';
import { isEqual } from 'lodash';
import PTOType from 'types/pto';
import { DISPLAY_DATE, RAILS_DATE } from 'config/constants';
import S from '../styles.scss';
import inputStyles from 'styles/input.scss';

const DATE_FORMAT = 'MM/DD/YYYY';
const INPUT_STYLE = `${inputStyles.inputElement} ${S.reasonInput}`;

class TimeOffTableRow extends React.Component {
  constructor(props) {
    super(props);
    this.state = this.mapPTO(this.props.pto);
  }

  componentWillReceiveProps = (nextProps) => {
    const { pto } = nextProps;
    if (pto.id !== 'new' && isEqual(pto, this.props.pto)) return;
    this.setState(this.mapPTO(pto));
  }

  mapPTO = (pto) => {
    const startDate = pto.start_date && moment(pto.start_date).format(DATE_FORMAT);
    const endDate = pto.end_date && moment(pto.end_date).format(DATE_FORMAT);
    const crew = (pto.assignee || {}).id || '';
    return { errors: {}, ...pto, start_date: startDate, end_date: endDate, crew };
  }

  validate = () => {
    const errors = {};
    if (this.props.isCrew && !this.state.crew) {
      errors.crew = 'Can\'t be blank';
      this.setState({ errors });
    }
    return Object.keys(errors).length === 0;
  }

  isNew = () => this.state.id === 'new';

  handleChange = attr => val => this.setState({ [attr]: val.target ? val.target.value : val });

  handleSave = () => this.validate() && this.whichSubmit();

  handleDelete = () => this.props.onDelete(this.state);

  handleCrewChange = this.handleChange('crew');
  handleStartDateChange = this.handleChange('start_date');
  handleEndDateChange = this.handleChange('end_date');
  handleReasonChange = this.handleChange('reason');

  whichSubmit = () => {
    const { parentObj, onSave, handleModalOpen } = this.props;
    const conflicts = parentObj && (parentObj.type || '') === 'estimator' ?
      this.estimatorConflicts(parentObj) : null;
    if (conflicts) {
      const stateCopy = { ...this.state };
      stateCopy.conflicts = conflicts;
      return handleModalOpen(stateCopy);
    }
    return onSave(this.state);
  }

  estimatorConflicts = (parentObj) => {
    const { start_date, end_date } = this.state;
    const { appointments = [] } = parentObj;
    const ptoStart = moment(start_date, DISPLAY_DATE);
    const ptoEnd = moment(end_date, DISPLAY_DATE);
    const conflicts = [];
    appointments.forEach((a) => {
      const { start_date: aStart, end_date: aEnd } = a;
      const apptStart = moment(aStart, RAILS_DATE);
      const apptEnd = moment(aEnd, RAILS_DATE);
      if (apptStart.isBetween(ptoStart, ptoEnd, 'days', '[]') ||
          apptEnd.isBetween(ptoStart, ptoEnd, 'days', '[]')) conflicts.push(a);
    });
    return conflicts.length ? conflicts.map(c =>
      ({ start_date: c.start_date, end_date: c.end_date }),
    ) : null;
  }

  renderCrewCell = () => {
    const { assignee, errors } = this.state;
    const { crews, isCrew } = this.props;
    const options = crews.map(crew => ({ label: crew.name, value: crew.id }));
    const value = (assignee || {}).name;
    const error = errors.crew;
    const cellProps = { label: 'Crew', display: isCrew, onChange: this.handleCrewChange, value, error };
    return (<EditableTableCell {...cellProps}>
      <StyledSelect options={options} value={this.state.crew} className={S.select} placeholder=" " />
    </EditableTableCell>);
  }

  renderDateTimeAddedCell = () => <EditableTableCell
    label="Date/Time Added"
    value={this.isNew() ? 'N/A' : this.props.pto.date_time_added}
    onChange={() => { }}
    cellReadOnly
  />

  renderAddedByCell = () => <EditableTableCell
    label="Added By"
    value={this.props.pto.added_by || (this.isNew() ? this.props.user : 'N/A')}
    onChange={() => { }}
    cellReadOnly
  />

  renderDateCell = (attr, label, onChange) => {
    const { pto } = this.props;
    const { errors } = this.state;
    const value = pto[attr] && moment(pto[attr]).format(DATE_FORMAT);
    const minDate = moment().subtract(1, 'day').toDate();
    const error = (errors.base || errors[attr] || [{}])[0].error;
    return (<EditableTableCell label={label} value={value} onChange={onChange} error={error}>
      <DatePicker value={this.state[attr]} minDate={minDate} className={S.datepicker} />
    </EditableTableCell>);
  }

  renderReasonCell = () => <EditableTableCell
    label="Comments" value={this.props.pto.reason} onChange={this.handleReasonChange}
  >
    <input type="text" value={this.state.reason || ''} className={INPUT_STYLE} />
  </EditableTableCell>

  render = () => {
    const disabled = moment().isAfter(moment(this.state.end_date, DATE_FORMAT), 'day');
    const rowProps = {
      isNew: this.isNew(), disabled, onSave: this.handleSave, onDelete: this.handleDelete,
    };
    return (<EditableTableRow className={this.props.className} {...rowProps}>
      {this.renderCrewCell()}
      {this.renderDateTimeAddedCell()}
      {this.renderAddedByCell()}
      {this.renderDateCell('start_date', 'Start Date', this.handleStartDateChange)}
      {this.renderDateCell('end_date', 'End Date', this.handleEndDateChange)}
      {this.renderReasonCell()}
    </EditableTableRow>);
  }
}

TimeOffTableRow.contextTypes = { isEditable: PropTypes.bool };

TimeOffTableRow.propTypes = {
  pto: PTOType.isRequired,
  handleModalOpen: PropTypes.func,
  onSave: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  crews: PropTypes.array,
  isCrew: PropTypes.bool,
  className: PropTypes.string,
  parentObj: PropTypes.object,
  user: PropTypes.string,
};

TimeOffTableRow.defaultProps = {
  crews: [],
  isCrew: false,
  className: '',
  parentObj: null,
  handleModalOpen: () => { },
};

export default TimeOffTableRow;



// WEBPACK FOOTER //
// ./client/app/shared/components/TimeOffTable/components/timeOffTableRow.jsx